import { ConditionalLink } from "components/conditionalLink";
import { stopPropagation } from "utils/stopPropagation";

type FilingTitleLinkProps = {
  taskUuid: string;
  title: string;
};

// Desktop opens the filing in a new tab; on mobile it opens in the same tab.
export const FilingTitleLink = ({ taskUuid, title }: FilingTitleLinkProps) => {
  return (
    <ConditionalLink
      to={`/tax/filings/${taskUuid}`}
      className="t-line-clamp-1 t-text-purple hover:t-text-purple hover:t-underline sm:t-line-clamp-none"
      target="_blank"
      onClick={stopPropagation}
    >
      {title}
    </ConditionalLink>
  );
};
